import React from 'react';
import { PayrollScreenDesktop } from './PayrollScreenDesktop';
import { PayrollScreenMobile } from './PayrollScreenMobile';

const MOBILE_BREAKPOINT = 1024; // px

const getIsMobile = () => {
  if (typeof window === 'undefined') return false;
  const widthMatch = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  return widthMatch || coarsePointer;
};

export const PayrollScreen = () => {
  const [isMobile, setIsMobile] = React.useState(getIsMobile());

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleChange = () => setIsMobile(getIsMobile());

    handleChange();

    const widthMedia = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const pointerMedia = window.matchMedia('(pointer: coarse)');

    if (widthMedia.addEventListener) {
      widthMedia.addEventListener('change', handleChange);
      pointerMedia.addEventListener('change', handleChange);
    } else {
      // Safari fallback
      widthMedia.addListener(handleChange);
      pointerMedia.addListener(handleChange);
    }

    window.addEventListener('orientationchange', handleChange);
    window.addEventListener('resize', handleChange);

    return () => {
      if (widthMedia.removeEventListener) {
        widthMedia.removeEventListener('change', handleChange);
        pointerMedia.removeEventListener('change', handleChange);
      } else {
        widthMedia.removeListener(handleChange);
        pointerMedia.removeListener(handleChange);
      }
      window.removeEventListener('orientationchange', handleChange);
      window.removeEventListener('resize', handleChange);
    };
  }, []);

  return isMobile ? <PayrollScreenMobile /> : <PayrollScreenDesktop />;
};

